import { useState } from 'react'
import { sound } from '../util/sound'
import '../css/App.css'

interface Props {
  onClose: () => void
}

/**
 * SEQ=10110 STEP=4 — 설정 모달
 * 현 단계 항목: 음소거 ON/OFF (localStorage 'board.muted' 기기별 영구화)
 * 서버 동기화 없음.
 */
export default function SettingsModal({ onClose }: Props) {
  const [muted, setMuted] = useState<boolean>(sound.isMuted())

  function handleToggle() {
    const next = !muted
    sound.setMuted(next)
    setMuted(next)
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <h3 className="modal-title">설정</h3>

        <div className="settings-row">
          <span className="settings-label">효과음</span>
          <label className="settings-toggle">
            <input
              type="checkbox"
              checked={!muted}
              onChange={handleToggle}
              aria-label="효과음 음소거 토글"
            />
            <span>{muted ? 'OFF (음소거)' : 'ON'}</span>
          </label>
        </div>

        <p className="muted" style={{ marginTop: 12, fontSize: '0.85em' }}>
          음소거 설정은 본 기기에만 저장됩니다 (서버 동기화 없음).
        </p>

        <div className="modal-btns" style={{ marginTop: 16 }}>
          <button className="btn-primary" onClick={onClose}>닫기</button>
        </div>
      </div>
    </div>
  )
}
